import * as manageTypes from './tabManagerType'
import useTabManager from './useTabManager'
import MyTabs from '../../../../control/tab/tab'
import useFolderAndTabStore from '../../../../stores/appFolderAndTab/appFolderAndTabStore'
import Dialog from '../../../../control/dialog/dialog'

//View
const TabManagerView = (props: manageTypes.ManageProjectView) => {
    const { onChangeTab, tabIndex, onRefDialog, configDialog } = props

    const folderAndTabStore = useFolderAndTabStore()
    const { tabRenderList } = folderAndTabStore

    return (
        <>
            <MyTabs onChangeTab={onChangeTab} tabIndex={tabIndex} tabList={tabRenderList} />
            <Dialog onRef={onRefDialog} {...configDialog} />
        </>
    )
}

//Controller
const TabManagerCtrl = (props: manageTypes.ManageProjectType) => {
    const {} = props
    const useTabManagerModel = useTabManager(props)
    return <TabManagerView {...props} {...useTabManagerModel} />
}

export default TabManagerCtrl
